
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[nonprofitSlugOrUsername]/nonprofits",
      function () {
        return require("private-next-pages/[nonprofitSlugOrUsername]/nonprofits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[nonprofitSlugOrUsername]/nonprofits"])
      });
    }
  